<label>Journey progress modules</label>
<div>
    <small class="text-muted">Only modules with defined categories are selectable here</small>
</div>
<dx-tag-box class="select-progress-products"
            [dataSource]="groupedProgressProducts"
            [grouped]="true"
            [disabled]="!!errorMessage"
            [readOnly]="isLoading"
            [placeholder]="isLoading ? 'Loading journey progress modules...' : 'Select journey progress modules...'"
            [value]="progressProductIds"
            (valueChange)="onValueChanged($event)"
            [showSelectionControls]="true"
            [dropDownOptions]="{ wrapperAttr: { class: 'select-progress-products-dropdown' } }"
            applyValueMode="instantly"
            [displayExpr]="progressProductTagText"
            itemTemplate="productItem"
            valueExpr="progressProductId"
            [showDropDownButton]="true">
    <div *dxTemplate="let product of 'productItem'">
        {{ progressProductDisplayExpr(product) }}
    </div>
</dx-tag-box>

@if (existingProducts.length > 0) {
    <div class="alert alert-danger mt-3 mb-0">
        The following modules conflict with an existing module or another selected module:
        <ul>
            @for (product of existingProducts; track product.progressProductId) {
                <li>
                    {{ progressProductTagText(product) }}
                </li>
            }
        </ul>
    </div>
}

@if (!isLoading && !errorMessage && groupedProgressProducts.length === 0) {
    <p class="text-muted">No eligible journey progress modules are available.</p>
}

@if (errorMessage) {
    <p class="alert alert-danger">{{ errorMessage }}</p>
}
